<template>
  <div>
      <full-page  ref="fullpageHome" :options="options" id="fullpage">

        <div id="section000"  class="section">
          <h2>LOADING...</h2>
        </div>

        <div id="section00" class="section">

          <div id="keyArt" class="keyArt keyArtAni"></div>
          <div id="keyArtBirds" class="keyArtBirds keyArtBirdsAni"></div>
          <div id="titleArt" class="titleArt titleArtAni"></div>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />

        </div>

        <div id="section01" class="section">
          <b-container fluid class="h-100">
            <b-row class="h-100 align-items-center justify-content-center">
              <b-col md="6" xl="5">
                <!-- <b-img src="../../static/img/gbLogo@2x.png" fluid class="theLogo" /> -->
                <div id="quote">
                <p class="quote">WHEN THE PEOPLE CAME TO AMERICA, THEY BROUGHT US WITH THEM…WE RODE IN THEIR MINDS, AND WE TOOK ROOT.</p>
                <p class="quoter">MR. WEDNESDAY</p>
                </div>
              </b-col>
            </b-row>
          </b-container>
          
         <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />

        </div>


        <div id="section02" class="section">
          <div id="buffaloBG" class="buffaloBG"></div>
          <div id="buffalo" class="buffalo"></div>
          <b-container class="h-100">
            <b-row class="h-100 align-items-end justify-content-center">
              <b-col sm="11">
                <div class="originStory">
                  <h2>The Origin Story</h2>
                  <p>When Shadow Moon is released from prison, he meets the mysterious Mr. Wednesday and a storm begins to brew. Left adrift by the recent death of his wife, Shadow is hired as Mr. Wednesday’s bodyguard. He finds himself in a hidden world where magic is real, where the Old Gods fear irrelevance and the growing power of the New Gods, and where Mr. Wednesday is building an army to reclaim his lost glory.</p>
                </div>
              </b-col>
            </b-row>
          </b-container>
          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
        </div>


        <div id="section03" class="section">

          <div id="illustrationBG" class="illustrationBG"></div>
          <div id="illustration" class="illustration"></div>

          <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />

        </div>

        <div id="section04" class="section">
          <b-container class="h-100">
            <b-row class="h-100 align-items-center justify-content-center">
              <b-col sm="10">
                  <div id="seasonTwoText">
                  <h1>SEASON TWO</h1>
                  <h2>MARCH 10</h2>
                  <p>We were forged in God’s image, but the Gods are also made in ours – and in Season Two the battle moves inexorably toward crisis point as the destinies of gods and men collide. While Mr. World plots revenge for the attack against him in Season One, Shadow throws in his lot with Wednesday’s attempt to convince the Old Gods of the case for full-out war, with Laura and Mad Sweeney in tow. A council at the House on the Rock explodes into chaos, sending deities both Old and New on quests across America that will converge on Cairo, Illinois: forcing Shadow to carve out a place as a believer in this strange new world of living gods – a dark world where change demands commitment, and faith requires terrible sacrifice.</p>
                  </div>
              </b-col>
            </b-row>
          </b-container>
          <!-- <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" /> -->

        </div>


      </full-page>
  </div>
</template>

<script>

export default {
  name: 'Home',
  metaInfo: {
    title: 'Home' // set a title
  },
  data () {
    return {
      options: {
        licenseKey: '08F6AFDB-F75D4F5A-AE124C87-3D28719F',
        menu: '#menu',
        anchors: ['loading', 'page1', 'page2', 'page3', 'page4', 'page5'],
        slidesNavigation: true,
        controlArrows: true,
        scrollOverflow: true,
        lazyLoading: false,
        onLeave: this.onLeave,
        afterLoad: this.afterLoad
      }
    }
  },
  methods: {
    afterLoad (origin, destination, direction) {
      if (destination.index === 0) {
        this.$refs.fullpageHome.api.moveSectionDown()
      }
    },
    onLeave (origin, destination, direction) {
      if (destination.index === 0) {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      if (origin.index === 1 && destination === 'up') {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      // KeyArt Animations
      var keyArt = document.querySelector('#keyArt')
      var keyArtBirds = document.querySelector('#keyArtBirds')
      var titleArt = document.querySelector('#titleArt')

      if (destination.index === 1) {
        keyArt.classList.add('keyArtAni')
        keyArtBirds.classList.add('keyArtBirdsAni')
        titleArt.classList.add('titleArtAni')
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      } else {
        keyArt.classList.remove('keyArtAni')
        keyArtBirds.classList.remove('keyArtBirdsAni')
        titleArt.classList.remove('titleArtAni')
        document.getElementById('stzHeaderTitleArt').classList.remove('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.add('logo')
      }
      // Quote Page Animations
      var quote = document.querySelector('#quote')
      if ((origin.index === 1 && direction === 'down') || (origin.index === 3 && direction === 'up')) {
        quote.classList.add('fadeInAni')
      }
      if ((origin.index === 2 && direction === 'down') || (origin.index === 2 && direction === 'up')) {
        quote.classList.remove('fadeInAni')
      }
      // Origin Story Animations
      var buffaloBG = document.querySelector('#buffaloBG')
      var buffalo = document.querySelector('#buffalo')
      if (destination.index === 2 || destination.index === 3 || destination.index === 4) {
        buffaloBG.classList.add('loadImage')
        buffalo.classList.add('loadImage')
      }
      if (destination.index === 3) {
        buffaloBG.classList.add('buffaloBGAni')
        buffalo.classList.add('buffaloAni')
      } else {
        buffaloBG.classList.remove('buffaloBGAni')
        buffalo.classList.remove('buffaloAni')
      }
      // Season 1 Animations
      var illustrationBG = document.querySelector('#illustrationBG')
      var illustration = document.querySelector('#illustration')
      if (destination.index === 3 || destination.index === 4 || destination.index === 5) {
        illustrationBG.classList.add('loadImage')
        illustration.classList.add('loadImage')
      }
      if (destination.index === 4) {
        illustrationBG.classList.add('illustrationBGAni')
        illustration.classList.add('illustrationAni')
      } else {
        illustrationBG.classList.remove('illustrationBGAni')
        illustration.classList.remove('illustrationAni')
      }
      // Season 2 Animations
      var seasonTwoText = document.querySelector('#seasonTwoText')
      var seasonTwoBG = document.querySelector('#section04')
      if (destination.index === 4 || destination.index === 5 || destination.index === 6) {
        seasonTwoBG.classList.add('loadImage')
        seasonTwoBG.classList.add('loadImage')
      }
      if (destination.index === 5) {
        seasonTwoText.classList.add('fadeInAni')
      } else {
        seasonTwoText.classList.remove('fadeInAni')
      }
    }
  },
  mounted: function () {
    // Hide the Title art on the Home Page
    document.getElementById('stzHeaderTitleArt').classList.remove('logo')
    document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
    // Set the header title art to display or not
    var btnLink = document.getElementsByClassName('btnLink')
    var i
    // Check for home page btn's
    for (i = 0; i < btnLink.length; i++) {
      btnLink[i].addEventListener('click', function () {
        // Set the Title Art in the Header
        document.getElementById('stzHeaderTitleArt').classList.remove('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.add('logo')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/Home.scss";

</style>



// WEBPACK FOOTER //
// src/components/HomeFull.vue